export const GET_EMPLOYEE_RESTRICTIONS = "GET_EMPLOYEE_RESTRICTIONS"
export const GET_LOBBYIST_STATUSES = "GET_LOBBYIST_STATUSES"
export const GET_ANNUAL_RETURN_TYPES = "GET_ANNUAL_RETURN_TYPES"


// WEBPACK FOOTER //
// ./src/actionTypes/lookupCode.js